import { recentMessagesHeadingSx } from "@/common/ChatInboxStyles";
import { Box, Skeleton, Stack, Typography } from "@mui/material";

const InboxShimmer = () => {
  return (
    <Box sx={{ width: "100%", p: 2 }}>
      {/* Search Bar Skeleton */}
      <Skeleton
        variant="rounded"
        width="100%"
        height={40}
        sx={{ mb: 2, borderRadius: "20px" }}
      />

      {/* Title Skeleton (optional real text if preferred) */}
      <Typography variant="h6" sx={recentMessagesHeadingSx}>
        Recent messages
      </Typography>

      {/* Scrollable List */}
      <Box
        sx={{
          maxHeight: "70vh",
          overflowY: "auto",
          pr: 1,
          scrollbarWidth: "thin",
          "&::-webkit-scrollbar": {
            width: "6px",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#a020f0", // Purple scrollbar
            borderRadius: "4px",
          },
        }}
      >
        <Stack spacing={2}>
          {[...Array(8)].map((_, idx) => (
            <Box key={idx} sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Skeleton variant="circular" width={40} height={40} />
              <Box sx={{ flexGrow: 1 }}>
                <Skeleton variant="text" width="60%" height={20} />
                <Skeleton variant="text" width="40%" height={16} />
              </Box>
            </Box>
          ))}
        </Stack>
      </Box>
    </Box>
  );
};

export default InboxShimmer;
